<table
	mat-table
	[dataSource]="items"
	matSort
	class="w-full table-auto border-none"
>
	<ng-container matColumnDef="title">
		<th class="text-base" mat-header-cell *matHeaderCellDef>
			{{ title }} ({{ items.length }})
		</th>
		<td mat-cell class="text-base" *matCellDef="let element">
			{{ element.title }}
		</td>

		<td
			class="font-bold border-t text-base"
			[ngClass]="{
				'align-bottom ': hst !== null,
				'align-middle': hst === null,
			}"
			mat-footer-cell
			*matFooterCellDef
		>
			Total
		</td>
	</ng-container>

	<ng-container matColumnDef="amount">
		<th mat-header-cell *matHeaderCellDef class="text-end text-base">Amount</th>
		<td mat-cell *matCellDef="let element" class="text-end text-base">
			{{ element.amount | centsToDollars }}
		</td>

		<td
			mat-footer-cell
			*matFooterCellDef
			class="text-end px-2 border-t text-base"
			[ngClass]="{
				'align-bottom ': hst !== null,
				'align-middle': hst === null,
			}"
		>
			<p class="text-xs mb-2" *ngIf="hst !== null">
				+ HST ({{ hst | percent }}) {{ hstTotal | centsToDollars }}
			</p>
			<p class="font-bold text-base">{{ total + hstTotal | centsToDollars }}</p>
		</td>
	</ng-container>

	<tr
		mat-header-row
		*matHeaderRowDef="displayedColumns"
		class="sticky top-0 z-10"
	></tr>
	<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
	<tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
</table>
